var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.fullscreenVisible
      ? _c("div", { class: _vm.classes }, [
          _c("div", { class: _vm.mainClasses }, [
            _c("span", { class: _vm.dotClasses }),
            _vm._v(" "),
            _c("div", { class: _vm.textClasses }, [_vm._t("default")], 2)
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e182ab76", { render: render, staticRenderFns: staticRenderFns })
  }
}